import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Input,
  Text,
  useDisclosure,
  Flex,
} from '@chakra-ui/react';
import CustomerApi from 'api/customer';

const PanVerificationModal = ({ isOpen, onClose, onVerify, userId, func }) => {
  const [panNumber, setPanNumber] = useState('');
  let clientID = '';

  const verifyPan = async (id, panNumber) => {
    try {
      const api = await CustomerApi.verifyPan({
        id,
        panNumber,
      });
      let response = api.data;
      console.log('Responde', response);
      if (response.status_code === 200) {
        response = response.data;
        clientID = response.client_id;
        console.log('Response of clientid', clientID);
      } else {
        console.log('Error generating OTP');
      }
    } catch (err) {
      console.log(err);
    }
  };
  let regex = new RegExp(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/);
  const handlePanSubmit = () => {
    console.log('pan number', panNumber);
    if (panNumber.length === 10) {
      verifyPan(userId, panNumber);
    }
    func();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Verify Aadhaar</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <>
            <Text>Enter your PAN Number</Text>
            <Input
              value={panNumber}
              onChange={(e) => setPanNumber(e.target.value)}
              placeholder='PAN Number'
              maxLength={12}
              mt={4}
            />
            <Button
              mt={4}
              colorScheme='blue'
              onClick={handlePanSubmit}
              isDisabled={panNumber.length !== 10}
            >
              Verify
            </Button>
          </>
        </ModalBody>
        <ModalFooter>
          <Button variant='ghost' onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default PanVerificationModal;
